import { Component, OnInit, OnDestroy } from '@angular/core';

import { SpinnerService } from './spinner.service';
import { SpinnerState } from './spinner';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-angular-spinner',
    templateUrl: 'spinner.component.html',
    styleUrls: ['spinner.component.css']
})
export class SpinnerComponent implements OnInit {

    show = false;

    private subscription: Subscription;

    constructor(
        private spinnerService: SpinnerService
    ) { }

    ngOnInit() { 
        this.subscription = this.spinnerService.spinnerSubject
            .subscribe((state: SpinnerState) => {
                this.show = state.show;
            });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}